<section class="hero-cover-search">
  <div class="position-relative">

    <video
      #heroVideo
      class="hero-media"
      muted
      autoplay
      loop
      playsinline
      preload="auto"
    >
      <source src="https://txl-videos.s3.ap-south-1.amazonaws.com/udaan-videos/hero-banner-vdo.webm" type="video/webm" />
    </video>

  </div>
</section>